import { PreSendData } from "@rpldy/shared-ui";
import { UploaderEnhancer } from "@rpldy/uploader";
import { PreSendResponse, UPLOADER_EVENTS } from "@rpldy/uploady";
import { documentCreate } from "gen/endpoints/documents/documents";
import { DocumentTypeEnum } from "gen/model/documentTypeEnum";
import { MimeTypeEnum } from "gen/model/mimeTypeEnum";
import { cloneDeep, set } from "lodash-es";

export const getDocumentEnhancer =
  (documentType: DocumentTypeEnum): UploaderEnhancer =>
  (uploader) => {
    uploader.on(
      UPLOADER_EVENTS.REQUEST_PRE_SEND,
      async ({ items }: PreSendData): Promise<PreSendResponse> => {
        const item = items[0];
        const responseDocument = await documentCreate({
          filename: item.file.name,
          mime_type: item.file.type as MimeTypeEnum,
          document_type: documentType,
        });
        // react-uploady needs to be able to mutate the document object
        const document = cloneDeep(responseDocument);

        // FIXME: Unsure if this is the right approach
        //  https://github.com/rpldy/react-uploady/discussions/492
        set(item, "document", document);
        items[0] = item;

        return {
          items,
          options: {
            destination: {
              url: document.url,
              headers: document.headers,
            },
            sendWithFormData: true,
            params: document.headers,
          },
        };
      },
    );
    return uploader;
  };
